define('widgets/dgrid/blocks/recommended/recommended',['underscore', 'knockout'], function (_, ko) {

    var RecommendedBlock = function (DGridData, cmsGames, getFields, gameIndex) {
        var self = this;

        self.gameIndex = gameIndex;

        self.headline = getFields('headline');

        self.recommendedGameId = ko.deferredComputed(function() {
            var games = DGridData.recommendedGames();

            return games.length > gameIndex ? games[gameIndex] : games[0];
        });

        self.game = cmsGames.mobileGames.getGameByProviderGameId(self.recommendedGameId);

    };

    return RecommendedBlock;
});

